import { createGlobalStyle } from "styled-components";
import OpenSansRegular from '../../assets/fonts/OpenSans-Regular.ttf';
// import OpenSansSemiBold from '../../assets/fonts/OpenSans-SemiBold.ttf';

export const GlobalStyle = createGlobalStyle`
  *{
    margin: 0;
    padding: 0;
  }
  @font-face {
    font-family: 'Open Sans';
    src: url(${OpenSansRegular}) format('ttf');
    font-weight: 400;
    font-style: normal;
  }
  html,
  body {
    height: 100%;
    width: 100%;
    min-width: 820px;
    font-size: 14px;
    letter-spacing: 0.5px;
    font-family: 'Open Sans', Arial;
  }
  button{
    line-height: 18px;
  }
  #root {
    min-height: 100%;
    min-width: 100%;
  }
  button:hover{
    cursor: pointer;
  }
  a:hover{
    cursor: pointer;
  }
  input::-webkit-outer-spin-button,
  input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
  input[type=number] { 
    -moz-appearance: textfield;
    appearance: textfield;
    margin: 0; 
  } 
  input{
    border: 2px solid #eee;
    outline: none;
    border-radius: 6px;
    padding: 6px 4px;
  }
`;

export const THEME = {
  colors: {
    blue:"#0085CF",
    darkBlue:"#31708F",
    ligthBlue:"#DAECF3",
    secondary:"#CCE6F5",
    darkGrey: "#3D3D3D",
    ligtGrey:"#EEEEEE",
    mediumGrey:'#666666',
  },
};
